import { render, staticRenderFns } from "./PageStaffManagement.vue?vue&type=template&id=821a9b1e&scoped=true"
import script from "./PageStaffManagement.vue?vue&type=script&lang=js"
export * from "./PageStaffManagement.vue?vue&type=script&lang=js"
import style0 from "./PageStaffManagement.vue?vue&type=style&index=0&id=821a9b1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "821a9b1e",
  null
  
)

export default component.exports